
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history'
import createRootReducer from '../reducers'

export const history = createBrowserHistory();

export default function configureStore() {
    const store = createStore(
      createRootReducer(history),
      composeWithDevTools(
        applyMiddleware(
          routerMiddleware(history), // for dispatching history actions
          thunk // for async actions
        ),
      ),
    )
  
    return store
}



// WEBPACK FOOTER //
// ./src/stores/store.ts